import React from "react";
import { FormattedMessage, } from '../../../../util/reactIntl';
import { PrimaryButton } from '../../../../components';

import css from './SectionCoupon.module.css';


export const SectionCoupon = props => {
  const {
    couponError,
    intl,
    handleChange,
    promoCode,
    isBusy,
    onApplyCoupon,
  } = props;

  return (
    <div className='col cen'>
      <p>
        <FormattedMessage id="MembershipPlansPage.couponInfo" />
      </p>
      <div className='row gap20'>
        <input
          className={css.input}
          type='text'
          placeholder={intl.formatMessage({ id: "MembershipPlansPage.couponPlaceholder" })}
          onChange={handleChange}
        />

        <PrimaryButton className={css.button} onClick={onApplyCoupon}
          disabled={!promoCode || isBusy}
          inProgress={isBusy}
        >
          <FormattedMessage id="MembershipPlansPage.applyCoupon" />
        </PrimaryButton>
      </div>

      {couponError &&
        <span className='error'>
          {couponError}
        </span>}

    </div>

  );
};
export default SectionCoupon;


